<!-- Minimal Floating Recording Indicator -->
<div class="recording-pill" 
     *ngIf="isVisible"
     [class.dragging]="isDragging"
     [style.left.px]="position.x"
     [style.top.px]="position.y"
     (mousedown)="onDragStart($event)"
     (touchstart)="onDragStart($event)">

  <!-- Recording/Paused: Dot + Time + Pause + Stop -->
  <ng-container *ngIf="state === 'recording' || state === 'paused'">
    <span class="rec-dot" 
          [class.paused]="state === 'paused'"
          [class.warning]="hasWarning"></span>
    <span class="rec-time">{{ formatTime(recordingTime) }}</span>
    
    <!-- Spacer to push buttons right -->
    <span class="spacer"></span>
    
    <!-- Pause/Resume button -->
    <button class="pill-btn pause" 
            (click)="togglePause(); $event.stopPropagation()"
            [title]="isPaused ? 'Resume (Space)' : 'Pause (Space)'">
      <i class="fa-solid" [class.fa-play]="isPaused" [class.fa-pause]="!isPaused"></i>
    </button>
    
    <!-- Stop button -->
    <button class="pill-btn stop" 
            (click)="stopRecording(); $event.stopPropagation()"
            title="Stop (Esc)">
      <i class="fa-solid fa-stop"></i>
    </button>
  </ng-container>

  <!-- Countdown -->
  <ng-container *ngIf="state === 'countdown'">
    <span class="rec-dot countdown"></span>
    <span class="rec-time">{{ countdown }}</span>
    <span class="spacer"></span>
  </ng-container>

  <!-- Processing -->
  <ng-container *ngIf="state === 'processing'">
    <i class="fa-solid fa-circle-notch fa-spin proc-icon"></i>
    <span class="rec-time">Saving...</span>
    <span class="spacer"></span>
  </ng-container>

  <!-- Uploading -->
  <ng-container *ngIf="state === 'uploading'">
    <div class="upload-ring">
      <svg viewBox="0 0 36 36">
        <circle class="bg" cx="18" cy="18" r="15.9"></circle>
        <circle class="progress" cx="18" cy="18" r="15.9" 
                [style.stroke-dashoffset]="100 - uploadProgress"></circle>
      </svg>
      <span class="upload-pct">{{ uploadProgress }}</span>
    </div>
    <span class="rec-time">Uploading</span>
    <span class="spacer"></span>
  </ng-container>
</div>
